import { CloudProviderWorker } from "./CloudProviderWorker";
import { inject, injectable } from "inversify";
import { CloudProvider } from "../lib/kotenna/CloudProvider";
import { Instance } from "../lib/kotenna/Instance";
import { VHost } from "../lib/kotenna/VHost";
import { KotennaApi } from "../lib/kotenna/KotennaApi";
import TYPES from "../TYPES";
import { ConsoleUI } from "../utils/ConsoleUI";

export interface AzureVmCloudProvider extends CloudProvider {
    appId: string;
    appSecret: string;
    tenantId: string;
    subscriptionId: string;
}

@injectable()
export class AzurevmWorker implements CloudProviderWorker {

    private  api: KotennaApi;
    private console: ConsoleUI;

    constructor( @inject(TYPES.ConsoleUI) ui: ConsoleUI, @inject(TYPES.KotennaApi) api: KotennaApi ) {
        this.console = ui;
        this.api = api;
    }

    async createProvider(): Promise<CloudProvider> {
        this.console.log("Azure authentication requires you to create an Azure AD application and service principal, granted with the builtin CONTRIBUTOR role.");
        this.console.log("You will be asked for:");
        this.console.log("* Application ID");
        this.console.log("* Application Secret");
        this.console.log("* Domain/Tenant ID");
        this.console.log("* Subscription ID");
        this.console.log(" ");
        this.console.log("Please refer to guide https://docs.porkettaio/azure.html");

        const appId = await this.console.promptInput("Application ID");
        const tenantId = await this.console.promptInput("Domain/Tenant ID");
        const appSecret = await this.console.promptInput("Application Secret");
        const subscriptionId = await this.console.promptInput("Subscription ID");
        const name = await this.console.promptInput("Choose a name for this CloudProvider");

        this.console.loaderStart("Saving...");
        return this.api.providerSave({
            name,
            api: "azurevm",
            appId,
            appSecret,
            tenantId,
            subscriptionId
        });

    }

    createVhost(hostname: string, instance: Instance, provider: CloudProvider, tpl: any): Promise<VHost> {
        return Promise.reject("NOT IMPLEMENTED");
    }

}